var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_627_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0114 20.0669H0V0H19.0114V20.0669Z",
    fill: "#EA4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7352 3.0639C10.0215 3.213 9.96194 3.4062 9.8739 4.319C9.78397 5.2605 9.4825 6.9804 8.90174 8.6723C8.32034 10.3614 7.45774 12.0211 6.70597 13.2496C5.95484 14.4788 5.312 15.2775 4.8218 15.7388C4.3297 16.2001 3.9896 16.3233 3.7673 16.3639C3.5469 16.4045 3.44684 16.3639 3.3873 16.24C3.32777 16.1168 3.30687 15.9138 3.35817 15.666C3.4082 15.421 3.5279 15.134 3.86737 14.7665C4.21 14.3976 4.7705 13.9461 5.55267 13.5268C6.33484 13.1068 7.33677 12.7176 8.15947 12.4509C8.98217 12.1856 9.6231 12.0414 10.1842 11.9287C10.7466 11.8153 11.2273 11.7348 11.6985 11.6928C12.1697 11.6536 12.6321 11.6536 13.083 11.6928C13.5339 11.7348 13.9747 11.8153 14.3566 11.9189C14.7366 12.0211 15.0584 12.1436 15.3389 12.3396C15.6189 12.5328 15.8602 12.7995 15.9799 13.0977C16.1015 13.3938 16.1015 13.7228 16.0008 13.9573C15.9007 14.1932 15.6993 14.336 15.4694 14.4193C15.2389 14.4998 14.9786 14.5201 14.667 14.4193C14.3566 14.3157 13.9944 14.0903 13.6144 13.7935C13.2337 13.496 12.8322 13.1271 12.3116 12.5538C11.7897 11.9805 11.1475 11.2028 10.6067 10.4447C10.0658 9.6866 9.6231 8.9495 9.32227 8.3244C9.0227 7.6993 8.86184 7.1876 8.73137 6.6759C8.6009 6.1628 8.50084 5.6511 8.46094 5.1905C8.42104 4.7299 8.4394 4.319 8.47994 3.9907C8.51984 3.6645 8.58127 3.4167 8.6807 3.2522C8.78077 3.0912 8.922 3.0072 9.02207 2.9666C9.12214 2.926 9.18294 2.926 9.24247 2.9155C9.302 2.905 9.36154 2.8847 9.45337 2.9155C9.54077 2.9449 9.65667 3.0233 9.77257 3.1031",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_627_3100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9eb3a43b3e5ec6b2880fb021e7b5408f.svg";
export { ForwardRef as ReactComponent };